// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const chandelure: PokeData = {
  "id": 609,
  "name": "chandelure",
  "height": 10,
  "weight": 343,
  "base_experience": 234,
  "types": [
    PokeType.GHOST,
    PokeType.FIRE
  ],
  "api_moves": [
    "ember",
    "fire-spin",
    "night-shade",
    "minimize",
    "confuse-ray",
    "smog",
    "curse",
    "pain-split",
    "shadow-ball",
    "will-o-wisp",
    "memento",
    "imprison",
    "astonish",
    "overheat",
    "flame-burst",
    "hex",
    "inferno"
  ],
  "moves": [
    "ember",
    "fire-spin",
    "night-shade",
    "confuse-ray",
    "curse",
    "shadow-ball",
    "spectral-snatch",
    "fire-ball",
    "flare-blitz",
    "eruption",
    "poltergeist",
    "shadow-sneak",
    "lick"
  ],
  "evolution_chain": {
    "id": 308,
    "item": null,
    "species": [
      {
        "name": "litwick",
        "order": 608,
        "types": [
          PokeType.GHOST,
          PokeType.FIRE
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "lampent",
        "order": 609,
        "types": [
          PokeType.GHOST,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 607,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 41,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      },
      {
        "name": "chandelure",
        "order": 610,
        "types": [
          PokeType.GHOST,
          PokeType.FIRE
        ],
        "evolves_from_species_id": 608,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": null,
            "item": {
              "name": "dusk-stone"
            },
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.USE_ITEM
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 100,
    "speed": 107,
    "ability_power": 193
  },
  "stat_changes": [],
  "catch_rate": 45,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
